import TR from 'i18n-jsautotranslate';

import Variable from '@/common//style/variable.scss';
import Constants from '@/common/utils/constants';
import * as Assembly from '@/common/utils/assembly';
import * as Encrypted from '@/common/utils/encrypted';
import * as Format from '@/common/utils/format';
import * as Utils from '@/common/utils/utils';
import * as Validate from '@/common/utils/validate';

import * as Function from '@/common/utils/function.js';

export default {
  $sn: {
    TR: TR,
    //
    color: Variable,
    constants: Constants,
    assembly: Assembly,
    encrypted: Encrypted,
    format: Format,
    utils: Utils,
    validate: Validate,
    //
    ...Function
  }
};
